import React from 'react';
import { Download, BookOpen } from 'lucide-react';
import ConverImage from '../assets/cta/cover.png';

const CTASection = () => {
  return (
    <section className="relative py-20 bg-gray-50 dark:bg-gray-900 overflow-hidden" id='cta'>
      {/* Google-themed ambient backgrounds */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 rounded-full blur-3xl animate-pulse bg-[#FBBC04]"></div>
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 rounded-full blur-2xl animate-pulse bg-[#EA4335]" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/3 right-1/3 w-72 h-72 rounded-full blur-3xl animate-pulse bg-[#4285F4]" style={{ animationDelay: '2s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 flex flex-col lg:flex-row items-center gap-12">
         {/* Image Section */}
        <div className="lg:w-1/2 flex justify-center relative animate-fadeInUp">
          <div className="glass-card p-4 rounded-3xl shadow-2xl">
            <img
              src={ConverImage}
              alt="Content Creation Illustration"
              className="rounded-2xl transform hover:scale-105 transition-transform duration-500"
            />
          </div>
        </div>
        
        {/* Text Section */}
        <div className="text-center lg:text-left lg:w-1/2 space-y-6 animate-fadeInUp" style={{ animationDelay: '200ms' }}>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 dark:text-white">
            Ready to Transform Your <span className='text-[#4285F4]'>Content Creation</span>?
          </h2>
          <p className="text-lg md:text-xl text-gray-700 dark:text-gray-300">
            Join thousands of creators who've revolutionized their workflow with AI-powered bulk content generation.
          </p>
          <div className="flex flex-wrap justify-center lg:justify-start gap-4 mt-8">
            <a
              href="https://chromewebstore.google.com/detail/glabs-automator-automate/lgijlcogpfkinhgaijjbocflajljjpen?utm_source=item-share-cb"
              className="relative group overflow-hidden bg-gradient-to-r from-[#34A853] to-[#0f9d58] dark:from-[#8B5CF6] dark:to-[#7C3AED] text-white font-bold px-8 py-4 rounded-2xl transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105 ripple-effect flex items-center"
            >
              <Download className="mr-2 h-5 w-5" />
              <span className="relative z-10">Download Now</span>
              <div className="absolute inset-0 bg-gradient-to-r from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
